import Icon from '@ant-design/icons';
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import { ReactComponent as ReserveSVG } from './svgs/ic-reserve.svg';
import { ReactComponent as DiningGroupSVG } from './svgs/ic-dining-group.svg';
import { ReactComponent as LockCardSVG } from './svgs/ic-lock-card.svg';
import { ReactComponent as SpoonForkSVG } from './svgs/ic-spoon-fork.svg';
import { ReactComponent as DoctorSVG } from './svgs/ic-doctor.svg';
import { ReactComponent as BusSVG } from './svgs/ic-bus.svg';
import { ReactComponent as BallStrokeSVG } from './svgs/ic-ball-stroke.svg';
import { ReactComponent as TwoKeysSVG } from './svgs/ic-two-keys.svg';
import { ReactComponent as ReservePriceSVG } from './svgs/ic-reserve-price.svg';
import { ReactComponent as DailySaleSVG } from './svgs/ic-daily-sale.svg';
import { ReactComponent as AvailableFoodSVG } from './svgs/ic-available-food.svg';
import { ReactComponent as ReserveReportSVG } from './svgs/ic-reserve-report.svg';
import { ReactComponent as FunctionReportSVG } from './svgs/ic-function-report.svg';
import { ReactComponent as KeySVG } from './svgs/ic-key.svg';
import { ReactComponent as KeyDoubleSVG } from './svgs/ic-key-double.svg';
import { ReactComponent as StudentSVG } from './svgs/ic-student.svg';
import { ReactComponent as CardSVG } from './svgs/ic-card.svg';
import { ReactComponent as OutlineExitSVG } from './svgs/ic-outline-exit.svg';
import { ReactComponent as AuthenticateSVG } from './svgs/ic-authenticate.svg';
import { ReactComponent as OutlineFeedbackSVG } from './svgs/ic-outline-feedback.svg';
import { ReactComponent as OutlineKeySVG } from './svgs/ic-outline-key.svg';
import { ReactComponent as OutlineMessagesSVG } from './svgs/ic-outline-messages.svg';
import { ReactComponent as OutlinePriceSVG } from './svgs/ic-outline-price.svg';
import { ReactComponent as OutlineSettingsSVG } from './svgs/ic-outline-settings.svg';

import { ReactComponent as ClinicReportSVG } from './svgs/ic-clinic-report.svg';
import { ReactComponent as ClinicReserveSVG } from './svgs/ic-clinic-reserve.svg';
import { ReactComponent as ClinicDailySaleSVG } from './svgs/ic-clinic-daily-sale.svg';

import { ReactComponent as DormitoryAttendanceReportSVG } from './svgs/ic-dormitory-attendance-report.svg';
import { ReactComponent as DormitoryCardexSVG } from './svgs/ic-dormitory-cardex.svg';
import { ReactComponent as DormitoryLaundrySVG } from './svgs/ic-dormitory-laundry.svg';
import { ReactComponent as DormitoryLeaveReportSVG } from './svgs/ic-dormitory-leave-report.svg';
import { ReactComponent as DormitoryLeaveSVG } from './svgs/ic-dormitory-leave.svg';
import { ReactComponent as DormitoryPaymentSVG } from './svgs/ic-dormitory-payment.svg';
import { ReactComponent as DormitorypreRegisterSVG } from './svgs/ic-dormitory-pre-register.svg';
import { ReactComponent as DormitoryRegisterSVG } from './svgs/ic-dormitory-register.svg';
import { ReactComponent as DormitoryExtendSVG } from './svgs/ic-dormitory-extend.svg';
import { ReactComponent as DormitoryGuestSVG } from './svgs/ic-dormitory-guest.svg';

import { ReactComponent as TransportReportSVG } from './svgs/ic-transport-report.svg';
import { ReactComponent as TransportReserveSVG } from './svgs/ic-transport-reserve.svg';
import { ReactComponent as TransportDailySaleSVG } from './svgs/ic-transport-daily.svg';

import { ReactComponent as SportActivitySVG } from './svgs/ic-sport-activity.svg';
import { ReactComponent as SportCapabilitiesSVG } from './svgs/ic-sport-capabilities.svg';
import { ReactComponent as SportDailySellSVG } from './svgs/ic-sport-daily-sell.svg';
import { ReactComponent as SportTicketSVG } from './svgs/ic-sport-ticket.svg';
import { ReactComponent as SportPackageSVG } from './svgs/ic-sport-package.svg';
import { ReactComponent as AttachmentsSVG } from './svgs/ic-attachments.svg';

import { ReactComponent as IssueNewSVG } from './svgs/ic-issue-new.svg';
import { ReactComponent as IssueSearchSVG } from './svgs/ic-issue-search.svg';


import { ReactComponent as SurveyReletivesInfo } from './svgs/ic-survey-relatives-info.svg';
import { ReactComponent as SurveyCulturalCapabilities } from './svgs/ic-survey-cultural-capabilities.svg';
import { ReactComponent as SurveyElectionCandidacy } from './svgs/ic-survey-election-candidacy.svg';
import { ReactComponent as SurveyElections } from './svgs/ic-survey-elections.svg';
import { ReactComponent as SurveySurvey } from './svgs/ic-survey-survey.svg';
import { ReactComponent as SurveyCompetition } from './svgs/ic-survey-competition.svg';
import { ReactComponent as SurveyCamp} from './svgs/ic-survey-camp.svg';
import { ReactComponent as SurveyWorkshop } from './svgs/ic-survey-workshop.svg';
import { ReactComponent as SurveyGraduation } from './svgs/ic-survey-graduation.svg';



export type IconProps = Partial<CustomIconComponentProps>;

// Export SVG files as react components
export { ReserveSVG };
export { AttachmentsSVG };
export { DiningGroupSVG };
export { LockCardSVG };
export { TwoKeysSVG };
export { ReservePriceSVG };
export { DailySaleSVG };
export { AuthenticateSVG };
export { AvailableFoodSVG };
export { ReserveReportSVG };
export { FunctionReportSVG };
export { KeySVG };
export { CardSVG };
export { StudentSVG };
export { SpoonForkSVG };
export { KeyDoubleSVG };
export { OutlineExitSVG };
export { OutlineFeedbackSVG };
export { OutlineKeySVG };
export { OutlineMessagesSVG };
export { OutlinePriceSVG };
export { OutlineSettingsSVG };
export { SportActivitySVG };
export { SportDailySellSVG };
export { SportCapabilitiesSVG };
export { SportTicketSVG };
export { SportPackageSVG };
export { BallStrokeSVG };
export { DoctorSVG };
export { BusSVG };
export { ClinicReportSVG };
export { ClinicReserveSVG };
export { ClinicDailySaleSVG };
export { TransportReportSVG };
export { TransportReserveSVG };
export { TransportDailySaleSVG };
export { IssueNewSVG };
export { IssueSearchSVG };
export { DormitoryAttendanceReportSVG };
export { DormitoryCardexSVG };
export { DormitoryLaundrySVG };
export { DormitoryLeaveReportSVG };
export { DormitoryLeaveSVG };
export { DormitoryPaymentSVG };
export { DormitorypreRegisterSVG };
export { DormitoryRegisterSVG };
export { DormitoryExtendSVG };
export { DormitoryGuestSVG };
export { SurveyReletivesInfo };
export { SurveyCulturalCapabilities };
export { SurveyElectionCandidacy };
export { SurveyElections };
export { SurveySurvey };
export { SurveyCompetition };
export { SurveyCamp };
export { SurveyWorkshop };
export { SurveyGraduation };

// Export svgs as ant icon components
export const ReserveIcon = (props: IconProps) => <Icon component={ReserveSVG} {...props} />;
export const AttachmentsIcon = (props: IconProps) => <Icon component={AttachmentsSVG} {...props} />;
export const DiningGroupIcon = (props: IconProps) => <Icon component={DiningGroupSVG} {...props} />;
export const LockCardIcon = (props: IconProps) => <Icon component={LockCardSVG} {...props} />;
export const TwoKeysIcon = (props: IconProps) => <Icon component={TwoKeysSVG} {...props} />;
export const ReservePriceIcon = (props: IconProps) => <Icon component={ReservePriceSVG} {...props} />;
export const DailySaleIcon = (props: IconProps) => <Icon component={DailySaleSVG} {...props} />;
export const AvailableFoodIcon = (props: IconProps) => <Icon component={AvailableFoodSVG} {...props} />;
export const ReserveReportIcon = (props: IconProps) => <Icon component={ReserveReportSVG} {...props} />;
export const FunctionReportIcon = (props: IconProps) => <Icon component={FunctionReportSVG} {...props} />;
export const KeyIcon = (props: IconProps) => <Icon component={KeySVG} {...props} />;
export const CardIcon = (props: IconProps) => <Icon component={CardSVG} {...props} />;
export const DoctorIcon = (props: IconProps) => <Icon component={DoctorSVG} {...props} />;
export const BusIcon = (props: IconProps) => <Icon component={BusSVG} {...props} />;
export const KeyDoubleIcon = (props: IconProps) => <Icon component={KeyDoubleSVG} {...props} />;
export const StudentIcon = (props: IconProps) => <Icon component={StudentSVG} {...props} />;
export const SpoonForkIcon = (props: IconProps) => <Icon component={SpoonForkSVG} {...props} />;
export const BallStrokeIcon = (props: IconProps) => <Icon component={BallStrokeSVG} {...props} />;
export const OutlineExitIcon = (props: IconProps) => <Icon component={OutlineExitSVG} {...props} />;
export const OutlineFeedbackIcon = (props: IconProps) => <Icon component={OutlineFeedbackSVG} {...props} />;
export const OutlineKeyIcon = (props: IconProps) => <Icon component={OutlineKeySVG} {...props} />;
export const OutlineMessagesIcon = (props: IconProps) => <Icon component={OutlineMessagesSVG} {...props} />;
export const OutlinePriceIcon = (props: IconProps) => <Icon component={OutlinePriceSVG} {...props} />;
export const OutlineSettingsIcon = (props: IconProps) => <Icon component={OutlineSettingsSVG} {...props} />;
export const SportActivityIcon = (props: IconProps) => <Icon component={SportActivitySVG} {...props} />;
export const SportDailySellIcon = (props: IconProps) => <Icon component={SportDailySellSVG} {...props} />;
export const SportCapabilitiesIcon = (props: IconProps) => <Icon component={SportCapabilitiesSVG} {...props} />;
export const SportTicketIcon = (props: IconProps) => <Icon component={SportTicketSVG} {...props} />;
export const SportPackageIcon = (props: IconProps) => <Icon component={SportPackageSVG} {...props} />;
export const AuthenticateIcon = (props: IconProps) => <Icon component={AuthenticateSVG} {...props} />;
export const ClinicReportIcon = (props: IconProps) => <Icon component={ClinicReportSVG} {...props} />;
export const ClinicReserveIcon = (props: IconProps) => <Icon component={ClinicReserveSVG} {...props} />;
export const ClinicDailySaleIcon = (props: IconProps) => <Icon component={ClinicDailySaleSVG} {...props} />;
export const DormitoryAttendanceReportIcon = (props: IconProps) => <Icon component={DormitoryAttendanceReportSVG} {...props} />;
export const DormitoryCardexIcon = (props: IconProps) => <Icon component={DormitoryCardexSVG} {...props} />;
export const DormitoryLaundryIcon = (props: IconProps) => <Icon component={DormitoryLaundrySVG} {...props} />;
export const DormitoryLeaveReportIcon = (props: IconProps) => <Icon component={DormitoryLeaveReportSVG} {...props} />;
export const DormitoryLeaveIcon = (props: IconProps) => <Icon component={DormitoryLeaveSVG} {...props} />;
export const DormitoryPaymentIcon = (props: IconProps) => <Icon component={DormitoryPaymentSVG} {...props} />;
export const DormitorypreRegisterIcon = (props: IconProps) => <Icon component={DormitorypreRegisterSVG} {...props} />;
export const DormitoryRegisterIcon = (props: IconProps) => <Icon component={DormitoryRegisterSVG} {...props} />;
export const DormitoryExtendIcon = (props: IconProps) => <Icon component={DormitoryExtendSVG} {...props} />;
export const DormitoryGuestIcon = (props: IconProps) => <Icon component={DormitoryGuestSVG} {...props} />;

export const TransportReportIcon = (props: IconProps) => <Icon component={TransportReportSVG} {...props} />;
export const TransportReserveIcon = (props: IconProps) => <Icon component={TransportReserveSVG} {...props} />;
export const TransportDailySaleIcon = (props: IconProps) => <Icon component={TransportDailySaleSVG} {...props} />;

export const IssueNewIcon = (props: IconProps) => <Icon component={IssueNewSVG} {...props} />;
export const IssueSearchIcon = (props: IconProps) => <Icon component={IssueSearchSVG} {...props} />;

export const SurveyReletivesInfoIcon = (props: IconProps) => <Icon component={SurveyReletivesInfo} {...props} />;
export const SurveyCulturalCapabilitiesIcon = (props: IconProps) => <Icon component={SurveyCulturalCapabilities} {...props} />;
export const SurveyElectionCandidacyIcon = (props: IconProps) => <Icon component={SurveyElectionCandidacy} {...props} />;
export const SurveyElectionsIcon = (props: IconProps) => <Icon component={SurveyElections} {...props} />;
export const SurveySurveyIcon = (props: IconProps) => <Icon component={SurveySurvey} {...props} />;
export const SurveyCompetitionIcon = (props: IconProps) => <Icon component={SurveyCompetition} {...props} />;
export const SurveyCampIcon = (props: IconProps) => <Icon component={SurveyCamp} {...props} />;
export const SurveyWorkshopIcon = (props: IconProps) => <Icon component={SurveyWorkshop} {...props} />;
export const SurveyGraduationIcon = (props: IconProps) => <Icon component={SurveyGraduation} {...props} />;

